<template>
  <div>
    <v-btn color="primary" text @click="loadStudents" class="text-none">
      <v-icon left>mdi-message-text</v-icon>
      GỬI TIN NHẮN ĐẾN APP
    </v-btn>

    <v-dialog v-model="dialog" max-width="800px" persistent scrollable>
      <BaseBodyDialog title="Gửi tin nhắn" :loading="loading" @close="dialog = false" @save="sendMessage">
        <v-alert v-if="!evaluateStudents || evaluateStudents.length === 0" type="warning" text dense>
          Chưa có dữ liệu học sinh để gửi tin nhắn
        </v-alert>
        <v-card outlined class="elevation-0 mt-6">
          <v-data-table
            v-model="selectedStudents"
            :headers="headers"
            :items="evaluateStudents"
            item-key="student.id"
            show-select
            class="elevation-0"
            :loading="loading"
            no-data-text="Danh sách trống"
            loading-text="Đang tải danh sách học sinh..."
            :footer-props="{
              itemsPerPageText: 'Số dòng mỗi trang:',
              itemsPerPageAllText: 'Tất cả',
            }"
          >
            <template #[`item.student.name`]="{ item }">
              <div class="font-weight-medium">{{ item.student.name }}</div>
            </template>
            <template #[`item.class.title`]="{ item }">
              <v-chip small>{{ item.class.title }}</v-chip>
            </template>
          </v-data-table>
        </v-card>
        <v-divider class="my-4"></v-divider>
        <PreviewMessageEvaluate v-model="message" />
      </BaseBodyDialog>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import PreviewMessageEvaluate from './PreviewMessageEvaluate.vue'
import { Post } from '@/plugins/api'
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'

export default {
  components: {
    PreviewMessageEvaluate,
    BaseBodyDialog,
  },
  props: {
    evaluateId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      teachers: [],
      dialog: false,
      message: '',
      loading: false,
      selectedStudents: [],
      headers: [
        {
          text: 'Học sinh',
          value: 'student.name',
          sortable: true,
          align: 'start',
        },
        {
          text: 'Lớp',
          value: 'class.title',
          sortable: true,
          align: 'start',
        },
      ],
    }
  },
  computed: {
    ...mapState('evaluateStudent', ['evaluateStudents']),
    ...mapGetters('auth', ['profile']),
  },
  methods: {
    ...mapActions('evaluateStudent', ['fetchEvaluateStudents']),
    ...mapActions('teachers', ['fetchTeachers']),

    async loadStudents() {
      this.loading = true
      try {
        await this.fetchEvaluateStudents({ evaluate: this.evaluateId })
        if (!this.evaluateStudents || this.evaluateStudents.length === 0) {
          this.$alert.error('Chưa có dữ liệu học sinh để gửi tin nhắn.')
          return
        }
        this.dialog = true
      } catch (error) {
        this.$alert.error('Có lỗi xảy ra khi tải danh sách học sinh')
      } finally {
        this.loading = false
      }
    },

    generateMessageContent(evaluateStudent) {
      const { student, evaluate, lesson, class: classInfo } = evaluateStudent
      const { evaluate_criteria, value } = evaluateStudent

      // Format date
      const lessonDate = new Date(lesson.date)
      const formattedDate = lessonDate.toLocaleDateString('vi-VN')

      // Create evaluation rows
      const evaluationRows = evaluate_criteria
        .map((criteria) => {
          const valueObj = value.find((v) => v.id === criteria._id)
          return `
          <div style="margin-bottom: 10px;">
            <strong>${criteria.title}:</strong> ${valueObj.value || 'N/A'}
          </div>
        `
        })
        .join('')
      let message = this.message
      if (message.includes('{Tên học sinh}')) message = message.replace('{Tên học sinh}', student.name || 'N/A')
      if (message.includes('{Ngày}')) message = message.replace('{Ngày}', formattedDate || 'N/A')
      if (message.includes('{Giờ học}'))
        message = message.replace('{Giờ học}', `${lesson.startTime || 'N/A'} - ${lesson.endTime || 'N/A'}`)
      if (message.includes('{Tên lớp}')) message = message.replace('{Tên lớp}', classInfo.title || 'N/A')
      if (message.includes('{Tên giáo viên}')) {
        const listTeachers = this.teachers.filter((teacher) => lesson.teachers.some((t) => t === teacher.id))
        const teacherNames = listTeachers.map((teacher) => teacher.name).join(', ')
        message = message.replace('{Tên giáo viên}', teacherNames || 'N/A')
      }

      if (message.includes('{Tiêu chí đánh giá}'))
        message = message.replace('{Tiêu chí đánh giá}', evaluationRows || 'N/A')
      if (message.includes('{Nội dung ghi chú}'))
        message = message.replace('{Nội dung ghi chú}', evaluate.notes || 'N/A')
      return message
    },

    async sendMessage() {
      if (!this.selectedStudents.length || !this.message) return

      this.loading = true
      try {
        this.teachers = await this.fetchTeachers()
        const promises = this.selectedStudents.map((student) => {
          const messageContent = this.generateMessageContent(student)
          const messageData = {
            staff: this.profile.id,
            content: messageContent,
            type: 'notification',
            senderMethod: 'app',
            config: 'immediately',
            data: {
              shortContent: 'Bạn có thông báo mới',
              smsOnly: false,
            },
            student: student.student.id,
          }
          return Post.create(messageData)
        })

        await Promise.all(promises)
        this.dialog = false
        this.message = ''
        this.selectedStudents = []
        this.$alert.success('Gửi tin nhắn thành công')
      } catch (error) {
        this.$alert.error('Có lỗi xảy ra khi gửi tin nhắn')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
